// extracted by mini-css-extract-plugin
export default {"listItem":"_09Signature_listItem__gKbzY","title":"_09Signature_title__ZBnov","extraContent":"_09Signature_extraContent__Dpd05","description":"_09Signature_description__20X6N"};